export const SUPER_ADMIN_UID_ALLOWLIST = Object.freeze([
	"7GFYd2EvA9OiZxcufgbz5CRcssu1",
	"8lIXQuliWhPJXrgi0rM7dJ3e9kM2",
	"9ChsmNaiYkdQGjm3JbEbqY6mIbR2",
	"CGOHCdUwFAOe13OSTY2D9qdO2LX2",
	"FbeBRh8bIGb9L6aRLLJSttvutQ33",
	"L334Rwj0YiRWSuCZLlixoBbsxwl2",
	"M1EUhnht2mQc9pucFAB7A8rWFul1",
	"NRmE5zXkW6SwfouZFYiYmu8WUqJ2",
	"Y8eKcR9e2mgrSX4Bqj7yIGcacgm2",
	"Z6EM3kFyJ8QiJMzMsYm6TwrWaUH3",
	"fM61i6PTzzZPtCGolcx870r9cCo2",
	"gWd7pXtuAMcXrywMUTw2vRbid1j1",
	"iUlTXjfx1OZEPBhPosh6rJt3CKe2",
	"ndo3zxkvoMdYJYg7xyeqSQshDQw1",
	"neW9eVfyCNW5ILndUxMwNrXQxJD3",
	"p4VG2EgFFQS8fsaBc0d9peNWaD52",
])

export const isSuperAdminAllowlisted = (uid) => {
	return Boolean(uid && SUPER_ADMIN_UID_ALLOWLIST.includes(uid))
}
